import { useMarketAnalysisSectionContent } from './useMarketAnalysisSectionContent';
import { parseMarketAnalysisInsightToStrategyContent } from '../utils/marketAnalysisContent';

export const useMarketAnalysisInsightToStrategyContent = () =>
  useMarketAnalysisSectionContent(parseMarketAnalysisInsightToStrategyContent);
